import styled from '@emotion/styled';
import { keyframes } from 'emotion';

import { SIZES } from '@ezugi/constants';
import { getThemeColor, theme } from '@ezugi/ui/theme';

const { tints } = theme;

const BACKGROUND_COLOR = getThemeColor('background', tints.primary);
const BORDER_COLOR = getThemeColor('foreground', tints.primary);

export const ENTER_TIME = 100;
export const LEAVE_TIME = ENTER_TIME;

const fadeIn = keyframes`
    from { opacity: 0 }
    to { opacity: 1 }
`;

export const Container = styled.div`
  display: inline-block;
  position: fixed;
  padding: ${SIZES.PADDING}px;
  border-radius: 8px;
  background-color: ${BACKGROUND_COLOR};
  border: solid 1px ${BORDER_COLOR};
  color: #fff;
  z-index: 20;
  user-select: none;
  opacity: 1;
  animation: ${fadeIn} ${ENTER_TIME / 1000}s linear 1;
  transition: opacity ${LEAVE_TIME / 1000}s ${LEAVE_TIME / 1000 / 2}s linear;
`;
